class DateHelpers {
    static formatToReadableDate(value) {
        let date = new Date(value);
        const day = date.toLocaleString('default', { day: '2-digit' });
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.toLocaleString('default', { year: 'numeric' });
        return day + ' ' + month + ', ' + year;
    }

    static formatToReadableTime(hour, min) {
        let suffix = ' AM'
        if (hour > 12) {
            hour = hour - 12;
            suffix = ' PM';
        }
        return (hour + '').padStart(2, '0') + ':' + (min + '').padStart(2, '0') + suffix;
    }
}

export { DateHelpers };